import { Input as AntdInput, InputProps as AntdInputProps } from 'antd'
import { colors } from '../../theme'

interface InputProps extends AntdInputProps {
  label?: string
  error?: string
}

export const Input = (props: InputProps) => {
  const { label, error } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {label && (
        <div style={{ width: 200, justifyItems: 'flex-end' }}>
          <span>{label}:</span>
        </div>
      )}
      <div style={{ width: '100%', marginBottom: 20 }}>
        <div style={{ width: '100%' }}>
          <AntdInput {...props} />
        </div>
        <div style={{ width: '100%', fontSize: 12, color: colors.error }}>
          {error}
        </div>
      </div>
    </div>
  )
}

Input.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 0
  }
}
